/**
 * @file       Deliberations routes, used by the whole deliberations module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { ifAuthenticated } from "@/router/navigationGuards";
import ByUrl from "@/modules/deliberations/byUrl.vue";
import keywordGraph from "@/modules/deliberations/keywordGraph.vue";
import arborescenceGraph from "@/modules/deliberations/arborescenceGraph.vue";
import statsGraph from "@/modules/deliberations/statsGraph.vue";
import Inbox from "@/modules/deliberations/Inbox.vue";
import Suggestions from "@/modules/deliberations/suggestions.vue";

/**
 * Deliberations routes.
 *
 * @type  {array}
 */
const routes = [
  {
    path: "/:teacher/:url",
    component: ByUrl,
    name: "deliberation.byUrl",
    meta: { layout: "dlibr" },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/:teacher/:url/answers/:id",
    component: ByUrl,
    name: "deliberation.byUrl.answers",
    meta: { layout: "dlibr" },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/:teacher/:url/list/messages",
    component: Inbox,
    name: "deliberation.messages",
    meta: { layout: "dlibr" },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/:teacher/:url/list/suggestions",
    component: Suggestions,
    name: "deliberation.suggestions",
    meta: { layout: "dlibr" },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/:teacher/:url/report/keyword",
    component: keywordGraph,
    name: "deliberation.keywordGraph",
    meta: { layout: "dlibr" },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/:teacher/:url/report/arborescence",
    component: arborescenceGraph,
    name: "deliberation.arborescenceGraph",
    meta: { layout: "dlibr" },
    beforeEnter: ifAuthenticated
  },
  {
    path: "/:teacher/:url/report/stats",
    component: statsGraph,
    name: "deliberation.statsGraph",
    meta: { layout: "dlibr" },
    beforeEnter: ifAuthenticated
  }
];

export default routes;
